import { atom } from "jotai";
import { FileListStatementType, FileStatusOptions } from "../Labeling.types";

export const fileListStatusOptionsAtom = atom<FileStatusOptions>(
    FileStatusOptions.UNLABELED,
);

export const fileListStatementTypeAtom = atom<FileListStatementType>("all");

export const fileListFileTypeAtom = atom<"uploads" | "connectors">(
    "connectors",
);
